var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDealFlow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.67188 14.8298C8.67188 16.1198 9.66188 17.1598 10.8919 17.1598H13.4019C14.4719 17.1598 15.3419 16.2498 15.3419 15.1298C15.3419 13.9098 14.8119 13.4798 14.0219 13.1998L9.99187 11.7998C9.20187 11.5198 8.67188 11.0898 8.67188 9.86984C8.67188 8.74984 9.54187 7.83984 10.6119 7.83984H13.1219C14.3519 7.83984 15.3419 8.87984 15.3419 10.1698",
    stroke: "#171717",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6.5V18.5",
    stroke: "#171717",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 22.5H9C4 22.5 2 20.5 2 15.5V9.5C2 4.5 4 2.5 9 2.5H15C20 2.5 22 4.5 22 9.5V15.5C22 20.5 20 22.5 15 22.5Z",
    stroke: "#171717",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDealFlow);
export default __webpack_public_path__ + "static/media/deal-flow.48e7058d8b1431fabdec29c83b032fd7.svg";
export { ForwardRef as ReactComponent };